import { listPinnedTimelineItems } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import {
  announcementEmbeds,
  awardEmbeds,
  incentiveEmbeds,
  recognitionEmbeds,
  awardTypeEmbeds,
} from '../timeline/useTimelineItems'

export const PINNED_TIMELINE_ITEMS_QK = 'pinnedTimelineItemsQueryKey'

const usePinnedTimelineItems = () => {
  const { data } = useQuery({
    queryKey: [PINNED_TIMELINE_ITEMS_QK],
    queryFn: () =>
      listPinnedTimelineItems({
        recognitionEmbeds,
        awardEmbeds,
        announcementEmbeds,
        incentiveEmbeds,
        awardTypeEmbeds,
        pageSize: 100,
      }),
  })

  return {
    data,
  }
}

export default usePinnedTimelineItems
